module ProcessList {
    "use strict";

    export interface IProcessInfo {
        version: number;
        triggersActive: boolean;
        triggers: string[];
        initializationExceptions: { [key:string] : string };
    }

    export class AgentStatus {
        public id: number;
        public name: string;
        public lastUpdate: Date;
        public lastStatus: string;
        public environment: string;
        public lastError: Date;
        public agentVersion: string;
        public isCorrectVersion: boolean;
        public processInfos: { [key: string]: IProcessInfo };
        public timestamp: Date;
    }

    export interface IEnvironmentAgents {
        environment: string;
        agents: AgentStatus[];
    }

    export class AgentStatusService {

        static $inject = ["$http", "$q"];
        constructor(private $http: ng.IHttpService, private $q: ng.IQService) {

        }

        public getAgentStatuses(agentGroupName: string, environmentName: string): ng.IPromise<AgentStatus[]> {
            var deferred = this.$q.defer<AgentStatus[]>();

            this.$http.get("Process/GetAgentStatuses", { params: { agentGroupName: agentGroupName, environmentName: environmentName } })
                .then((response: any) => {
                    if (response && response.data.success) {
                        deferred.resolve(response.data.data);
                    } else {
                        deferred.reject(response.data && response.data.errorMessage);
                    }
                })
                .catch(reason => deferred.reject(reason));

            return deferred.promise;
        }
    }
    module.service("AgentStatusService", AgentStatusService);
}